import request from '@/utils/request'

export async function getDept(data) {
  return request({
    url: '/depart/all',
    method: 'post',
    data,
  })
}
export async function searchDept(data) {
  return request({
    url: '/depart/get',
    method: 'post',
    data,
  })
}
export async function createDept(data) {
  return request({
    url: '/depart/save',
    method: 'post',
    data,
  })
}
export async function updateDept(data) {
  return request({
    url: '/depart/update',
    method: 'post',
    data,
  })
}
export async function deleteDept(data) {
  return request({
    url: '/depart/delete',
    method: 'post',
    data,
  })
}
